import { Component, EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  MenuBreadCrumb,
  params,
  TableColumns,
  TableConfiguration,
} from 'brainloper-ui';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { Resources } from 'app/models2/maintenance/resources';
import { WorkOrder } from 'app/models2/maintenance/work-order';
import { User } from 'app/models2/administration/user';
import { Data } from 'app/models2/commos/base-response-data';
import { CommentService } from 'app/services/comment.service';

@Component({
  selector: 'app-maintenance-execution',
  templateUrl: './maintenance-execution.component.html',
  styleUrls: ['./maintenance-execution.component.scss'],
})
export class MaintenanceExecutionComponent implements OnInit {
  public urlGetTablaResourcesRequest: string = `${EndpointDictionary.ResourcesRequest.RESOURCES_REQUEST_TABLE}`;

  public view: boolean = false;
  private order;
  public estado: number = 0;
  public bodyOrden: WorkOrder = {};
  public bodyUsuarios: User[] = [];
  public orderId: number;

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: 'Inicio',
      router: '/inicio',
    },
    {
      name: 'Notificaciones',
    },
    {
      name: 'Ejecución Mtto',
      current: true,
    },
  ];

  public resources: Array<Resources> = [{ itemName: '' }];

  public reloadResoucesRequest = new EventEmitter<any>();
  public paramsResourcesRequest: params[] = [{ id: 'requestId', value: '0' }];
  public configurationResouces: TableConfiguration = {
    edit: false,
    add: false,
    delete: false,
    selectable: false,
    addPer: false,
    editPer: false,
    primaryKey: 'id',
    print: false,
  };
  public columnsResouces: TableColumns<Resources>[] = [
    {
      ID: 'itemName',
      label: 'Nombre',
      type: 'combo',
      disregardForEdit: true,
      style: {
        textAlign: 'center',
      },
      paramsCombo: {
        selectionField: 'id',
        visibleField: 'name',
        urlParams: [],
        url: `${EndpointDictionary.Item.ITEM_COMBO}`,
      },
    },
    {
      ID: 'unitMeasurement',
      label: 'Unidad',
      type: 'text',
      disregardForAdd: true,
      disregardForEdit: true,
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'amount',
      label: 'Cantidad',
      type: 'number',
      style: {
        textAlign: 'center',
      },
    },
  ];

  constructor(
    private activeRoute: ActivatedRoute,
    private commentService: CommentService
  ) {}

  ngOnInit(): void {
    this.init();
  }

  async init() {
    this.activeRoute.queryParamMap.subscribe(async (params) => {
      this.order = { ...params };
      this.orderId = this.order.params.id_orden_trabajo;
    });
  }

  dataResources($event: Data<Array<Resources>>) {
    this.resources = $event.data;
  }

  close() {
    this.estado = 1;
  }

  addComment(workOrder: WorkOrder) {
    this.commentService.addComment(this.orderId);
  }
}
